import { createSlice } from "@reduxjs/toolkit";
import { fetchBrands, fetchBrandById, updateBrand, addBrand } from "./thunk";

interface brandState {
  brandList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedBrand: any;
}

const initialState: brandState = {
  brandList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedBrand: null,
};

const brandSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBrands.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBrands.fulfilled, (state, action) => {
        state.loading = false;
        state.brandList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchBrands.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch brands";
      })
      .addCase(fetchBrandById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBrandById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedBrand = action.payload;
      })
      .addCase(fetchBrandById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateBrand.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.brandList = state.brandList.map((brand) =>
          brand.id === action.payload.id ? action.payload : brand
        );
      })
      .addCase(updateBrand.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update brand";
      })
      .addCase(addBrand.fulfilled, (state, action) => {
        // Brand added successfully, will be refetched on list page
      })
      .addCase(addBrand.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to add brand";
      });
  },
});

export default brandSlice.reducer;

